import { Form } from 'react-bootstrap';
import styled from 'styled-components';

export const SelectGroupStyled = styled(Form.Group)`
  .customSelectOption {
    display: flex;
    cursor: pointer;
    align-items: center;
  }

  .SelectGroup__option {
    border-bottom: 1px solid #e6e6e6;
  }
`;
